export default "__VITE_ASSET__LG_$VhAD__"